<template>
  <div class="header">
    <div class="title" v-if="openIndex && fromroute">
      <div class="goback" @click="goback()" :style="!style ? '' : 'color:#ffff'">
        <i class="el-icon-back"></i>
      </div>
      <span>
        {{ title }}
      </span>
      <el-switch v-model="switchValue" active-color="#498AF4" inactive-color="#b8b8b8" :active-value="true"
        :inactive-value="false" active-text="开" inactive-text="关"
        :disabled="!roleBtnCodes.includes('AIControl_module_switch')" @change="runBtn()"></el-switch>
      <div class="cbrBtn">
        <el-button v-for="(item, index, id) in allControlData.result.pool" :key="item.id" type="primary" size="mini"
          :style="cbrBtnStyle(index)" :disabled="!roleBtnCodes.includes('AIControl_pool_switch')"
          @click="cbrBtn(index, id)">{{ item.id }}
        </el-button>
      </div>
      <div class="statusdes" :style="!style ? '' : 'color:#ffff'">
        {{ allControlData.result.operate_status.des }}
        <span v-if="allControlData.result.operate_status.status < 5">
          <span class="status_color" style="background-color: #d43030"
            v-if="allControlData.result.operate_status.status == 2"></span>
          <span class="status_color" style="background-color: #fa9600"
            v-if="allControlData.result.operate_status.status == 3"></span>
          <span class="status_color" style="background-color: #498af4"
            v-if="allControlData.result.operate_status.status == 4"></span>
        </span>
      </div>
    </div>
    <div class="tenant-info" v-else>
      <img class="logo" src="../../assets/shuhan-logo.png" />
    </div>
    <navbar class="navbar" ref="menuRef"></navbar>
    <div class="admin">
      <div style="display: flex; justify-content: flex-end; cursor: pointer">
        <div class="touxiang">
          <img src="../../assets/touxiang.png" />
        </div>
        <span class="admin">admin</span>
      </div>
      <!-- <div class="logout-btn" @click="loginout"></div> -->
    </div>

    <el-dialog v-if="reasondialogVisible" title="关闭AI原因" :visible.sync="reasondialogVisible" width="30%"
      :before-close="cancelclose" center>
      <div>
        <div v-for="(item, index) in reasonlist" class="reasonitem" :key="index">
          <el-checkbox-group v-model="checkList">
            <el-checkbox :label="item.desc">
              {{ item.desc }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea" v-if="checkList.includes('其他原因说明')">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelclose()">取 消</el-button>
        <el-button type="primary" @click="commitclose()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Navbar from "./components/NavBar.vue";
import config from "@/utils/config.js";
import commonApi from "@/api/common";

export default {
  components: { Navbar },
  data() {
    return {
      tenantInfo: {},
      tenantList: [],
      tenantIds: {},
      displayMode: "boardMode",
      openIndex: undefined,
      fromroute: undefined,
      switchValue: true,
      style: false,
      allControlData: {
        result: {
          runbtn: false,
          table: [],
        },
      },
      roleBtnCodes: [],
      noticelength: 0,
      textarea: null,
      reasonlist: [
        {
          desc: "现场施工",
          index: 0,
        },
        {
          desc: "仪表维护",
          index: 1,
        },
        {
          desc: "仪表异常",
          index: 2,
        },
        {
          desc: "硬件检修",
          index: 3,
        },
        {
          desc: "出水指标过高",
          index: 4,
        },
        {
          desc: "出水指标过低",
          index: 5,
        },
        {
          desc: "其他原因说明",
          index: -1,
        },
      ],
      reason: null,
      checkList: [],
      reasondialogVisible: false,
    };
  },
  created() {
    this.getTenantInfo();
    this.getTenantList();
    this.getTenantIds();

    this.openIndex = this.$route.query.index;
    this.fromroute = this.$route.query.from;
    if (this.$route.path === "/openMore") {
      this.fromroute = "have";
    }

    if (this.openIndex) {
      this.getmodeltype();
    }

    let theme = localStorage.getItem("theme")
      ? JSON.parse(localStorage.getItem("theme"))
      : "light";
    this.style = theme == "light" ? false : true;

    if (theme == "light") {
      this.$store.commit("", theme);
    } else {
      this.$store.commit("changetype", theme);
    }
    document.documentElement.setAttribute("theme", theme);
  },
  watch: {
    $route(to, from) {
      console.log(to.path);
      if (to.path == "/ai/control") {
        this.$store.dispatch("getModulesInitall");
      }
      if (to.path == "/openMore") {
        this.havedata = true;
        this.openIndex = this.$route.query.index;
        this.fromroute = "have";
        this.getmodeltype();
        window.sessionStorage.setItem("havedata", true);
      } else {
        this.havedata = false;
        this.openIndex = this.$route.query.index;
        this.fromroute = this.$route.query.from;
        console.log(this.openIndex);
        window.sessionStorage.setItem("havedata", false);
      }
    },
    "$store.state.roleBtnCodes": {
      handler(val) {
        this.roleBtnCodes = val || [];
      },
      immediate: true,
    },
    "$store.state.displayMode": {
      handler(val) {
        this.displayMode = val || "boardMode";
      },
      immediate: true,
    },
  },
  methods: {
    getTenantList() {
      const type = sessionStorage.getItem("type");
      this.$http
        .get(
          type === "management"
            ? config.manageHttpPrefix + "/sys/user/tenants"
            : config.tenantHttpPrefix + "/tenant/user/tenants"
        )
        .then((res) => {
          if (res.data && res.data.code === 0) {
            this.tenantList = res.data.data || [];
          }
        });
    },
    getTenantInfo() {
      this.$http.get(config.tenantHttpPrefix + "/tenant/detail").then((res) => {
        if (res.data && res.data.code === 0) {
          this.tenantInfo = res.data.data;
        }
      });
    },
    handleTenantList(val) {
      sessionStorage.setItem("tenantId", val);
      localStorage.setItem("tenantId", val);
      this.getTenantInfo();

      this.$store.dispatch("getRoleMenuData").then((res) => {
        this.$refs.menuRef.getMenuList();
        if (res.length) {
          if (res[0].menuUrl === this.$route.path) {
            this.$router.go(0);
          } else {
            this.$router.push(res[0].menuUrl);
          }
        } else {
          this.$router.push("/404");
        }
      });
    },
    // 获取租户id、拼音简称
    getTenantIds() {
      this.$http
        .get(`${config.tenantHttpPrefix}/tenant/dictionary/data/list/TENANT_ID`)
        .then((res) => {
          if (res.data.code === 0) {
            const tenants = {};
            res.data.data.map((item) => {
              tenants[item.description] = item.code;
            });
            this.tenantIds = tenants;
            this.$store.commit("setTenantIds", tenants);
          }
        });
    },
    async getmodeltype() {
      const { data: res } = await this.$http.get(config.httpPrefix + "/modules/init", {
        params: { index: this.openIndex },
      });
      console.log(res);
      this.allControlData = res.data;
      this.title = res.data.result.name;
      this.switchValue = res.data.result.runbtn;
    },
    goToNotice() {
      this.$router.push({
        path: "/notice",
      });
    },
    goback() {
      this.$router.go(-1);
    },
    handleCommand(command) {
      console.log(command);
      if (command == "theme") {
        this.style = !this.style;
        console.log(this.style);
        // this.$store.commit("changetype", this.style);
        this.$store.commit("changeTheme");
        if (this.style == false) {
          document.documentElement.setAttribute("theme", "light");
          localStorage.setItem("theme", JSON.stringify("light"));
        } else if (this.style == true) {
          document.documentElement.setAttribute("theme", "dark");
          localStorage.setItem("theme", JSON.stringify("dark"));
        }
      } else if (command == "displayMode") {
        if (this.displayMode === "boardMode") {
          this.displayMode = "dataMode";
        } else {
          this.displayMode = "boardMode";
        }
        this.$store.commit("setDisplayMode", this.displayMode);
        sessionStorage.setItem("displayMode", this.displayMode);
      } else if (command == "aiEyes") {
        this.changeaieyes();
        this.$store.commit("setDisplayMode", "aiEyes");
        sessionStorage.setItem("displayMode", "aiEyes");
      } else {
        this.loginout();
      }
    },
    changeaieyes() {
      commonApi.saveUserAction({
        module: "AI-eyes",
        path: `AI之眼首页`,
        // 查看详情
        action: "ai_ChangeAiEyes",
      });
    },
    loginout() {
      const desktopApp = sessionStorage.getItem("desktopApp");
      if (desktopApp) {
        this.$router.push("/login");
      } else {
        window.top.location.href = `${location.protocol}//${location.host}/tenant-web/#/login`;
      }
    },
    async runBtn() {
      if (this.switchValue == true) {
        const { data: res1 } = await this.$http.post(
          config.httpPrefix + "/modules/control",
          {
            index: this.openIndex,
            flag: true,
          }
        );
        if (res1.meta.status == 403) {
          this.getmodeltype();
          return this.$message.error(res1.meta.msg);
        }
        if (res1.meta.status == 200) {
          return this.$message.success(res1.meta.msg);
        } else {
          this.getmodeltype();

          return this.$message.error(res1.meta.msg);
        }
      } else if (this.switchValue == false) {
        this.reasondialogVisible = true;
      }
    },
    async cbrBtn(index, id) {
      id = this.allControlData.result.pool[index].id;
      // console.log(this.inAerationData);
      // console.log(id);
      if (this.allControlData.result.pool[index].flag == true) {
        const { data: res1 } = await this.$http.post(
          config.httpPrefix + "/modules/pool",
          {
            index: this.allControlData.index,
            id: id,
            flag: false,
          }
        );
        if (res1.meta.status == 403) {
          // this.getControlData(this.openIndex);
          this.getmodeltype();
          return this.$message.error(res1.meta.msg);
        }
      } else if (this.allControlData.result.pool[index].flag == false) {
        const { data: res2 } = await this.$http.post(
          config.httpPrefix + "/modules/pool",
          {
            index: this.allControlData.index,
            id: id,
            flag: true,
          }
        );
        if (res2.meta.status == 403) {
          this.getmodeltype();
          return this.$message.error(res2.meta.msg);
        }
      }
      this.getmodeltype();
    },
    cbrBtnStyle(index) {
      if (this.allControlData.result.pool[index].flag == true) {
        return { backgroundColor: "#1890ff", color: "fff" };
      } else {
        return { backgroundColor: "#b8b8b8", color: "fff" };
      }
    },
    onModalShow(type) {
      if (type === "qualityTesting") {
        this.$emit("openQualityTesting");
      }
    },
    cancelclose() {
      this.reasondialogVisible = false;
      this.getmodeltype();
    },
    async commitclose() {
      console.log(this.checkList);
      if (this.checkList.length == 0) {
        return this.$message.error("请选择关闭原因");
      } else {
        let choselist = [];
        this.checkList.map((v) => {
          this.reasonlist.map((q) => {
            if (v == q.desc) {
              if (v == "其他原因说明") {
                choselist.push({
                  index: q.index,
                  desc: this.textarea,
                });
              } else {
                choselist.push({
                  index: q.index,
                  desc: q.desc,
                });
              }
            }
          });
        });
        const { data: res2 } = await this.$http.post(
          config.httpPrefix + "/modules/control",
          {
            index: this.openIndex,
            flag: false,
          }
        );
        this.reasondialogVisible = false;
        if (res2.meta.status == 403) {
          this.getmodeltype();

          return this.$message.error(res2.meta.msg);
        }
        if (res2.meta.status == 200) {
          this.dialogVisible = false;
          this.getmodeltype();

          return this.$message.success(res2.meta.msg);
        } else {
          this.getmodeltype();
          return this.$message.error(res2.meta.msg);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  padding: 0 30px;
  width: 100%;
  height: 60px;
  display: grid;
  grid-template-columns: 3fr 5fr 3fr;
  align-items: center;
  justify-content: space-between;
  font-size: 22px;
  background: rgba(38, 87, 143, 1);
  box-sizing: border-box;

  .title {
    font-size: 20px;
    color: black;
    display: flex;
    align-items: center !important;

    .cbrBtn {
      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-left: 20px;
    }

    .goback {
      margin-right: 15px;
      cursor: pointer;
    }

    span {
      margin-right: 30px;
    }

    .statusdes {
      margin-left: 20px;
      font-size: 20px;

      .status_color {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: red;
      }
    }
  }

  .tenant-info {
    display: flex;
    align-items: center;
    height: 60px; 
  }

  .logo {
    width: 140px;
  }

  .el-dropdown-link {
    margin-left: 20px;
    font-size: 22px;
    color: #fff;

    .iconfont {
      font-size: 20px;
    }
  }

  .touxiang {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    padding: 3px;
    width: 38px;
    height: 38px;
    background: url("../../assets/yuan.png") no-repeat;
    background-size: 100% 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .admin {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: #fff;
    font-size: 14px;

    .data-transmission {
      margin-right: 36px;
      display: flex;
      align-items: center;

      .el-switch {
        margin-right: 4px;
      }
    }

    .quality-testing {
      margin-right: 30px;
      width: 87px;
      height: 30px;
      opacity: 1;
      border-radius: 34px;
      background: rgba(236, 245, 255, 1);
      border: 0.5px solid rgba(73, 138, 244, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
      color: rgba(73, 162, 255, 1);
      cursor: pointer;
    }

    .notice {
      cursor: pointer;
      position: relative;
      margin-right: 50px;

      .notice_length {
        font-size: 12px;
        width: 16px;
        height: 16px;
        opacity: 1;
        border-radius: 16px;
        color: #fff;
        background: rgba(184, 75, 75, 1);
        position: absolute;
        top: -28%;
        right: -40%;
      }

      img {
        width: 18px;
        height: 21px;
      }
    }

    .logout-btn {
      margin-left: 30px;
      width: 20px;
      height: 18px;
      background: url("../../assets/logout.png") no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
}

:root[theme="dark"] {
  .header {
    background: #101116 !important;
    display: grid;
    grid-template-columns: 3fr 3fr 3fr;
  }
}
</style>
